export const SUCCESS_RESPONSE = "Success"
export const FAILED_RESPONSE = "Failed"


export const ApiResponseSuccess = 1
export const APiResponseError = 0

export const ApiResponseStatusOk = 200
export const ApiResponseStatusNotFound = 400
export const ApiResponseStatusUnauthorized = 401
export const ApiResponseStatusInternalServerError = 500

export const AxiosNetworkError = "ERR_NETWORK"

export const EmptyString = ""
export const Undefined = "undefined"
export const DefaultErrorMessage = "An error has occured. Please contact IT Support"

export const FormTypeAdd = "Add"
export const FormTypeEdit = "Edit"
export const FormTypeView = "View"

export const PageTypeGetPaged = "GetPaged"
export const PageTypeCount = "Count"

export const PageSize = 25

export const PaginationFirst = "First"
export const PaginationBack = "Back"
export const PaginationNext = "Next"
export const PaginationLast = "Last"

export const GuidDefault = "00000000-0000-0000-0000-000000000000"
export const DateNullDefault = "0001-01-01T00:00:00"

export const Active = "Active"
export const Deleted = "Deleted"

export const StatusCodeActive = "1"
export const StatusCodeDelete = "2"

export const DateInsertFormat = "yyyy-MM-DD"
export const SmallDateFormat = "DD MMM yyyy"

export const DropdownStatusList = [
    {label: "All", value: "0"},
    {label: "Active", value: "1"},
    {label: "Delete", value: "2"}
]

export const DropdownPaymentType = [
    {label: "All", value: "0"},
    {label: "Termin 1", value: "1"},
    {label: "Termin 2", value: "2"},
    {label: "Termin 3", value: "3"},
    {label: "Termin 4", value: "4"},
    {label: "Termin 5", value: "5"},
]

export const DropdownGender = [
    {label: "Select Gender", value: ""},
    {label: "Male", value: "1"},
    {label: "Female", value: "2"},
]
export const DropdownReligion = [
    {label: "Select Religion", value: ""},
    {label: "Islam", value: "1"},
    {label: "Hindu", value: "2"},
    {label: "Budha", value: "3"},
    {label: "Kong Hu Chu", value: "4"},
    {label: "Kristen", value: "5"},
    {label: "Katholik", value: "6"},
    {label: "Others", value: "7"}
]
export const DropdownNationality = [
    {label: "Select Nationality", value: ""},
    {label: "WNI", value: "1"},
    {label: "Foreigner", value: "2"},
]
export const DropdownMaritalStatus = [
    {label: "Select Marital Status", value: ""},
    {label: "Single", value: "1"},
    {label: "Married", value: "2"},
    {label: "Widowed", value: "3"},
    {label: "Divorced", value: "4"},
]
export const DropdownPosition = [
    {label: "Select Position", value: ""},
    {label: "Director", value: "1"},
    {label: "HR", value: "2"},
    {label: "Manager", value: "3"},
    {label: "Supervisor", value: "4"},
    {label: "Attendance", value: "5"},
    {label: "Juru Parkir", value: "6"},
]

export const DropdownTransactionType = [
    {label: "All", value: ""},
    {label: "Car Parking", value: "1"},
    {label: "Motorcycle Parking", value: "2"},
    {label: "Valet", value: "3"}
]
export const DropdownIsAdmin = [
    {label: "Admin", value: ""},
    {label: "Employee", value: ""}
]
export const DropdownTransactionStatus = [
    {label: "All", value: ""},
    {label: "Open", value: "1"},
    {label: "Close", value: "2"}
]
export const DropdownTransactionStatusOptions = [
    {label: "Select Transaction Status", value: ""},
    {label: "Open", value: "1"},
    {label: "Close", value: "2"}
]
export const DropdownPageSizeOptions = [
    {label: "25", value: "25"},
    {label: "50", value: "50"},
    {label: "100", value: "100"},
    {label: "All", value: ""}
]
export const SessionStatusOptions = [
    {label: "All", value: ""},
    {label: "Open", value: "0"},
    {label: "Closed", value: "1"}
]
export const TransactionTypeOptions = [
    {label: "Car Parking", value: "1"},
    {label: "Motorcycle Parking", value: "2"},
    {label: "Valet", value: "3"}
]

export const SidebarOpen = "open"
export const SidebarClose = "close"

export const MenuHomeId = ""
export const MenuCompanyId = ""
export const MenuBankId = ""
export const MenuProjectId = "4"
export const MenuPaymentId = "5"
export const MenuPaymentSubConId = "6"
export const MenuIncProjectId = "7"
export const MenuSubConId = "8"
export const MenuProductionBankId = "9"
